// extracted by mini-css-extract-plugin
export default {"content":"organization-module--content--2fsf5","images":"organization-module--images--2lcRk"};